import styled from 'styled-components'
import { colors } from '../../../colors'

export const LineElement = styled.div`
    height: 1.5px;
    display: block;
    background-color: ${(colors.blue)};
    width: 100%;
`
